import { useState, useContext } from 'react';
import { XCircle } from 'lucide-react';
import AuthContext from '../../../../../../../context/AuthContext';
import { useToast } from '../../../../../../../context/ToastContext';
import ConfirmationModal from '../../../../../../../components/ConfirmationModal';
import auditProgramService from '../../../../../../../services/audit_services/auditProgramService';

export default function CloseProgramModal({ isOpen, onClose, programId, programTitle, onSuccess }) {
  const { authTokens } = useContext(AuthContext);
  const { showError, showSuccess } = useToast();
  const [loading, setLoading] = useState(false);

  const handleClose = async () => {
    setLoading(true);
    
    try {
      const result = await auditProgramService.closeAuditProgram(authTokens.access, programId);
      
      if (result.success) {
        showSuccess('Programme d\'audit clôturé avec succès');
        onSuccess();
        onClose();
      } else {
        showError(result.error || 'Erreur lors de la clôture du programme d\'audit');
      }
      setLoading(false);
    } catch (error) {
      console.error('Error closing audit program:', error);
      showError('Erreur lors de la clôture du programme d\'audit');
      setLoading(false);
    }
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleClose}
      title="Clôturer le programme d'audit"
      message={`Êtes-vous sûr de vouloir clôturer le programme d'audit "${programTitle}" ? Cela clôturera également tous les plans d'audit de ce programme qui ne sont pas déjà clôturés ou archivés.`}
      confirmText={loading ? 'Clôture...' : 'Clôturer le programme'}
      confirmButtonClass="bg-red-600 hover:bg-red-700"
      icon={<XCircle className="h-6 w-6 text-red-600" />}
      loading={loading}
    />
  );
}